// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3yXx7","modalForm":"UpgradeEpcsModal_modalForm__1fvDW","modalFooter":"UpgradeEpcsModal_modalFooter__2E-5N"};